// extracted by mini-css-extract-plugin
export default {"heading":"SeguroUupoPage_heading__WN6tn","contentHeading":"SeguroUupoPage_contentHeading__n9uYE","content":"SeguroUupoPage_content__S-2DQ"};